import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { ProjectModalDesktop } from '../../../../components/ProjectModal';
import { ResponsiveSliderContainer } from '../../../ResponsiveSliderContainer';
import { IProjectModalContainerBaseProps } from '../../types';
import { PhoneButtonContainer } from '../../../PhoneButtonContainer';
import { SLIDER_PADDING } from './constants';
import { IImage } from '../../../../types/builder';
import { CallbackButtonContainer } from '../../../CallbackButtonContainer';
import { ECallbackWidgetPlacement } from '../../../../types/callbackWidget';

export type IProjectModalContainerDesktopProps = IProjectModalContainerBaseProps;

export const ProjectModalContainerDesktop: React.FC<IProjectModalContainerDesktopProps> = ({
  onClose,
  onPhoneButtonClick,
  ...project
}) => {
  const renderSlide = (slide: IImage) => <Image src={slide.full} objectFit="contain" />;

  return (
    <ProjectModalDesktop
      {...project}
      onClose={onClose}
      slider={<ResponsiveSliderContainer slides={project.images} renderSlide={renderSlide} padding={SLIDER_PADDING} />}
      phoneButton={<PhoneButtonContainer withIcon onShow={onPhoneButtonClick} />}
      callbackButton={<CallbackButtonContainer placement={ECallbackWidgetPlacement.HouseGallery} />}
    />
  );
};
